import AdminRouter from '../stylemix-vue-admin/router'

AdminRouter.addRoute({
  name: 'company-pricings.city-taxi',
  path: '/company-pricings/city-taxi',
  component: () => import('./CityTaxiPricing.vue'),
  meta: {
    auth: true,
    newLayout: true,
  },
})

AdminRouter.addRoute({
  name: 'company-pricings.city-taxi.index',
  path: '/company-pricings/city-taxi/index',
  component: () => import('./CityTaxiPricingIndex.vue'),
  meta: {
    auth: true,
  },
})

AdminRouter.addRoute({
  name: 'company-pricings.transfer',
  path: '/company-pricings/transfer',
  component: () => import('./TransferPricing.vue'),
  meta: {
    auth: true,
    newLayout: true,
  },
})

AdminRouter.addRoute({
  name: 'company-pricings.transfer.index',
  path: '/company-pricings/transfer/index',
  component: () => import('./TransferPricingIndex.vue'),
  meta: {
    auth: true,
  },
})
